import React from "react";

function Colors_2018() {
  return (
    <div>
      <h1>Colors_2018 Component</h1>
      <p>This is the Colors 2018 tutorial page content.</p>
    </div>
  );
}

export default Colors_2018;
